/**
 * Application Routes Schema
 * Single source of truth for all route paths
 * Import and use these constants instead of hardcoding route strings
 */

export const ROUTES = {
  // Auth Routes
  AUTH: {
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    VERIFY_OTP: "/verify-otp",
    CREATE_PASSWORD: "/create-password",
    CHANGE_PASSWORD: "/change-password",
  },

  // Dashboard Routes
  DASHBOARD: {
    HOME: "/",
    ORDER_MANAGEMENT: "/order",
    ORDER_CREATE: "/order/create",
    ORDER_EDIT: (id: string) => `/order/${id}/edit`,
    ORDER_VIEW: (id: string) => `/order/${id}`,

    PRODUCT_MANAGEMENT: "/product",
    PRODUCT_VIEW: (id: string) => `/product/${id}`,
    SUBCATEGORIES: "/subcategories",
    REPAIR_MANAGEMENT: "/repair-management",
    REPAIR_VIEW: (id: string) => `/repair-management/${id}`,
    ACCOUNT_SETTINGS: "/account-settings",
    CHANGE_PASSWORD: "/change-password",
    DESIGN_GUIDE: "/design-guide",
    MANUFACTURES: "/manufactures",
    MANUFACTURES_ADD: "/manufactures/add",
    MANUFACTURES_EDIT: (id: string) => `/manufactures/${id}/edit`,
    MANUFACTURES_VIEW: (id: string) => `/manufactures/${id}`,
    CUSTOMERS: "/customers",
    CUSTOMERS_ADD: "/customers/add",
    CUSTOMERS_EDIT: (id: string | number) => `/customers/${id}/edit`,
    CUSTOMERS_VIEW: (id: string | number) => `/customers/${id}`,
    GOLD_USERS: "/gold/users",
    GOLD_USER_VIEW: (id: string | number) => `/gold/users/${id}`,
    GOLD_TRANSACTIONS: "/gold/transactions",
    GOLD_TRANSACTION_VIEW: (id: string | number) => `/gold/transactions/${id}`,
    SILVER_USERS: "/silver/users",
    SILVER_USER_VIEW: (id: string | number) => `/silver/users/${id}`,
    SILVER_TRANSACTIONS: "/silver/transactions",
    SILVER_TRANSACTION_VIEW: (id: string | number) => `/silver/transactions/${id}`,
    PORTFOLIO_USERS: "/portfolio/users",
    PORTFOLIO_USER_VIEW: (id: string | number) => `/portfolio/users/${id}`,
    PORTFOLIO_TRANSACTIONS: "/portfolio/transactions",
    PORTFOLIO_TRANSACTION_VIEW: (id: string | number) => `/portfolio/transactions/${id}`,
    PAYOUTS: "/payouts",
    PAYOUTS_VIEW: (id: string | number) => `/payouts/${id}`,
    CMS: "/cms",
    CMS_TERMS: "/cms/terms",
    CMS_PRIVACY: "/cms/privacy",
    CMS_HELP: "/cms/help",
    SETTINGS: "/settings",
    SETTINGS_ACCOUNT: "/settings/account",
    SETTINGS_PRICING: "/settings/pricing",
    BROADCAST_MANAGEMENT: "/settings/broadcast-management",
    BROADCAST_ADD: "/broadcast-management/add",
  },

  // Root
  ROOT: "/",
} as const;

/**
 * Type-safe route type for navigation
 */
export type RouteKey =
  (typeof ROUTES)[keyof typeof ROUTES][keyof (typeof ROUTES)[keyof typeof ROUTES]];
